import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _get from 'lodash-es/get';
import _noop from 'lodash-es/noop';
import Layout from 'sushiweb/Layout/Layout';
import H5 from 'sushiweb/Typography/Heading/H5';
import H6 from 'sushiweb/Typography/Heading/H6';
import Button from 'sushiweb/Button/Button';
import grey from 'sushiweb/tokens/color/grey';
import red from 'sushiweb/tokens/color/red';
import H1 from 'sushiweb/Typography/Heading/H1';
import H4 from 'sushiweb/Typography/Heading/H4';
import H2 from 'sushiweb/Typography/Heading/H2';
import Spinner from 'sushiweb/Spinner';
import CheckCircleFill from 'sushiweb/Icons/all/CheckCircleFill';
import green from 'sushiweb/tokens/color/green';
import { P } from 'sushiweb/Typography';
import { StyledLayout } from '../../../../styles';
import CreateProgramModalContext from '../../../CreateProgramModalContext';
import Card from '../../../../../common/components/Card';
import {
  paymentRequestTypeEnum,
  programTypeEnum,
} from '../../../../../common/components/constants';
import { FormCacheContext } from '../../common/Components/FormTemplate/FormTemplate';
import {
  employeeCountForAdhocPrograms,
  formatAmountInRupees,
  totalAmountForAdhocProgram,
} from '../../../../../../helpers';
import {
  DottedLine,
  FundsSummaryText,
  GiftingPlanResponseStateWrapper,
  LinkWrapper,
  LinkWrapperSpan,
  PaymentMethodText,
} from '../AddEmployeeToProgram/styles';
import { DetailsContainer } from '../../../../../common/components/DetailsWrapper/styles';
import {
  AlignItemsWrapper,
  ContentsWrapper,
  DownloadButtonWrapper,
  JustifyContentWrapper,
  PollingModalsSpinnerHolder,
  PollingStateWrapper,
  ReponseHeader,
  ReportModalBtnStyle,
  ReportModalBtnStyleRed,
  SpinnerWrapper,
} from '../../../../../Reports/CreateReportModal/styles';
import {
  GET_PAYMENT_REQUEST_LOG,
  GET_PROGRAM_INFO,
  HOST,
} from '../../../../../../constants/urls';
import useProgramInfoPolling from '../../../../../common/utils/useProgramInfoPolling';
import usePaymentPolling from '../../../../../common/utils/usePaymentPolling';
import { updatePaymentModes } from '../../../../../../api/giftCard';
import { genericErrorMsg } from '../../../../../../constants';
import CopyToClipboard from '../../../../../common/components/CopyToClipboard/CopyToClipboard';
import ZTrackingClient from '../../../../../../jumbo/ZTrackingClient';

const ConfirmAdhocProgramCreation = ({
  subTitle,
  planData,
  creatingProgram,
  createProgram,
  createProgramSuccess,
  programAmount,
  pocEmail,
  programID,
  selectedWorkspace,
  totalEmployees,
  payableAmount,
  executionDate,
  showErrorToast,
}) => {
  const DetailsWrapper = styled(DetailsContainer)`
    position: relative;
    cursor: pointer;
    padding: 1rem;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.04);
    border: 1px solid ${grey.z200};

    &:hover {
      box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
    }

    &.selected {
      border: 1.3px solid ${red.z600};
      background: ${red.z50};
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
    }
  `;

  console.log(pocEmail);
  const { setModalSubtitle } = useContext(CreateProgramModalContext);
  const { bodyStyle } = useContext(FormCacheContext);
  const [selectedMethod, setSelectedMethod] = useState(0);
  const [paymentStatementFilePath, setPaymentStatementFilePath] = useState('');
  const [payReqId, setPayReqId] = useState('');
  const [payNowLink, setPayNowLink] = useState('');
  const [programPollingStarted, setProgramPollingStarted] = useState(false);
  const [programPollingCounter, setProgramPollingCounter] = useState(0);
  const [payReqPollingStarted, setPayReqPollingStarted] = useState(false);
  const [payReqPollingCounter, setPayReqPollingCounter] = useState(0);
  const [pollingFrequency, setPollingFrequency] = useState(2);
  const navigate = useNavigate();

  const formData = {
    pId: planData?.program_id ?? programID,
    amount: planData?.amount ?? programAmount,
    employeeCount: planData?.program_id
      ? employeeCountForAdhocPrograms(planData)
      : totalEmployees,
    payAmount: planData?.program_id
      ? totalAmountForAdhocProgram(planData)
      : formatAmountInRupees(payableAmount),
    execDate: planData?.start_date ?? executionDate,
  };

  const handleSelection = method => {
    setSelectedMethod(method);
    ZTrackingClient.recordClick({
      ui_source: 'SEND_EGIFT_CARD_MODAL',
      component: 'PAYMENT_METHOD',
      meta_data: { payment_method: paymentRequestTypeEnum[method] },
    });
  };

  const { closeModal } = useContext(CreateProgramModalContext);
  const [flag, setFlag] = useState(false);

  const footerStyle = {
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    gap: '2rem',
    margin: '0 0 1rem 0',
  };

  const redirectToPaymentPage = link => {
    setTimeout(() => {
      navigate(`/payments/online-payment/${link}`);
      setPayReqPollingStarted(false);
    }, 2000);
  };

  const startPayReqPolling = () => {
    setPayReqPollingStarted(true);
  };

  const onPayReqResponse = ({ isError, response }) => {
    setPayReqPollingCounter(payReqPollingCounter + 1);
    const respStatus = _get(response, 'status_response.status', false);
    const paymentFilePath = _get(
      response,
      'data.payment_statement_file_path',
      '',
    );
    setPaymentStatementFilePath(paymentFilePath);
    if (isError) {
      setPayReqPollingStarted(false);
      return;
    }
    if (!respStatus) {
      setPayReqPollingStarted(false);
    }
    if (paymentFilePath !== '' && paymentFilePath !== undefined) {
      setPayReqPollingStarted(false);
    } else {
      setPollingFrequency(3);
    }
  };

  usePaymentPolling({
    paymentRequestID: payReqId,
    frequency: pollingFrequency,
    isPollingStarted: payReqPollingStarted,
    onResponse: onPayReqResponse,
    url: GET_PAYMENT_REQUEST_LOG,
  });

  const onResponse = ({ isError, response }) => {
    const pollingCount = programPollingCounter + 1;
    setProgramPollingCounter(pollingCount);

    const respStatus = _get(response, 'status', false);
    const paymentReq = _get(response, 'data.payment_request', {});
    const link = _get(paymentReq, 'payment_request_id', '');

    setPayNowLink(`${HOST}/online-payment/${link}`);
    setPayReqId(link);

    if (pollingCount === 5 || isError || !respStatus) {
      setProgramPollingStarted(false);
      return;
    }

    switch (selectedMethod) {
      case paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_NOW:
        if (link !== '') {
          redirectToPaymentPage(link);
        }
        break;
      case paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_VIA_LINK:
        if (link !== '') {
          setProgramPollingStarted(false);
        }
        break;
      case paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_OFFLINE:
        if (link !== '') {
          setProgramPollingStarted(false);
          startPayReqPolling();
        }
        break;
      default:
  <></>;
    }
  };

  useProgramInfoPolling({
    programId: formData.pId,
    workspaceId: selectedWorkspace?.workspace_id,
    frequency: pollingFrequency,
    isPollingStarted: programPollingStarted,
    onResponse,
    url: GET_PROGRAM_INFO,
  });

  useEffect(() => {
    setModalSubtitle(subTitle);
  }, []);

  const paymemtMethods = [
    {
      value: paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_NOW,
      method: 'Pay Now',
      description: 'Use credit or debit card, UPI or other online mode',
    },
    {
      value: paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_VIA_LINK,
      method: 'Generate Link',
      description: 'Send link to a colleague for online payment',
    },
    {
      value: paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_OFFLINE,
      method: 'Bank Transfer',
      description: 'Generate a pdf for this amount for NEFT/RTGS',
    },
  ];

  useEffect(() => {
    if (creatingProgram) setFlag(true);
  }, [creatingProgram]);

  useEffect(() => {
    if (!creatingProgram && flag && createProgramSuccess) {
      setFlag(false);
      setProgramPollingStarted(true);
    }
  }, [flag, creatingProgram, createProgramSuccess]);

  const handleConfirmClick = () => {
    ZTrackingClient.recordClick({
      ui_source: 'SEND_EGIFT_CARD_MODAL',
      component: 'CONFIRM_BUTTON',
    });
    if (planData?.program_id) {
      updatePaymentModes({
        workspace_id: selectedWorkspace?.workspace_id,
        program_id: formData.pId,
        accepted_payment_modes: [selectedMethod],
      })
        .then(res => {
          if (!res?.status_response?.status) {
            showErrorToast(genericErrorMsg);
            return;
          }
          setProgramPollingStarted(true);
        })
        .catch(err => {
          console.error(err);
          showErrorToast(genericErrorMsg);
        });
    } else {
      const programBody = {
        workspace_id: selectedWorkspace?.workspace_id,
        program_id: formData.pId,
        program_type: programTypeEnum.PROGRAM_TYPE_ADHOC,
        accepted_payment_modes: [selectedMethod],
      };
      createProgram({ programBody });
    }
  };

  return (
    <>
      <Card.Body style={bodyStyle}>
        {!programPollingStarted &&
          !payReqPollingStarted &&
          payNowLink === '' &&
          paymentStatementFilePath === '' ? (
            <>
              <StyledLayout gap={10}>
                <Layout.Item colD={4} colT={4} colM={4}>
                  <FundsSummaryText>
                    <H5>Gift card value</H5>
                  </FundsSummaryText>
                </Layout.Item>
                <Layout.Item colD={8} colT={8} colM={8}>
                  <FundsSummaryText>
                    <H5>{formatAmountInRupees(formData.amount)}</H5>
                  </FundsSummaryText>
                </Layout.Item>
                <Layout.Item colD={4} colT={4} colM={4}>
                  <FundsSummaryText>
                    <H5>No. of recipients</H5>
                  </FundsSummaryText>
                </Layout.Item>
                <Layout.Item colD={8} colT={8} colM={8}>
                  <FundsSummaryText>
                    <H5>{formData.employeeCount}</H5>
                  </FundsSummaryText>
                </Layout.Item>
                <DottedLine> </DottedLine>
                <Layout.Item colD={4} colT={4} colM={4}>
                  <FundsSummaryText>
                    <H4>Amount payable</H4>
                  </FundsSummaryText>
                </Layout.Item>
                <Layout.Item colD={8} colT={8} colM={8}>
                  <FundsSummaryText>
                    <H4>{formData.payAmount}</H4>
                  </FundsSummaryText>
                </Layout.Item>
                <DottedLine> </DottedLine>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <FundsSummaryText>
                    <H4>Select mode of payment</H4>
                    <H6>
                      Gift cards will be automatically sent to the recipients once
                      the payment is received.
                    </H6>
                  </FundsSummaryText>
                </Layout.Item>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <div
                    style={{ display: 'flex', gap: '2rem', marginTop: '1rem' }}
                  >
                    {paymemtMethods.map(paymentMethod => (
                      <DetailsWrapper
                        key={paymentMethod.value}
                        className={
                        selectedMethod === paymentMethod.value ? 'selected' : ''
                      }
                        onClick={() => handleSelection(paymentMethod.value)}
                        value={paymentMethod.method}
                      >
                        <PaymentMethodText>
                          <H2>{paymentMethod.method}</H2>
                          <H1>{paymentMethod.description}</H1>
                        </PaymentMethodText>
                      </DetailsWrapper>
                  ))}
                  </div>
                </Layout.Item>
              </StyledLayout>
            </>
        ) : (
          <>
            <GiftingPlanResponseStateWrapper>
              <PollingStateWrapper>
                {programPollingStarted || payReqPollingStarted ? (
                  <ReponseHeader>
                    <PollingModalsSpinnerHolder>
                      <SpinnerWrapper>
                        <Spinner color={red.z_red} size='large' />
                      </SpinnerWrapper>
                      <P>
                        {selectedMethod ===
                          paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_NOW &&
                          'Redirecting to payment page...'}
                        {selectedMethod ===
                          paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_VIA_LINK &&
                          'Generating payment link...'}
                        {selectedMethod ===
                          paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_OFFLINE &&
                          'Generating proforma invoice...'}
                      </P>
                    </PollingModalsSpinnerHolder>
                  </ReponseHeader>
                ) : (
                  <ReponseHeader>
                    <AlignItemsWrapper>
                      <ContentsWrapper>
                        <JustifyContentWrapper>
                          <CheckCircleFill
                            color={green.z500}
                            size='10rem'
                            style={{ padding: '0px 30px 30px 30px' }}
                          />
                        </JustifyContentWrapper>
                        <JustifyContentWrapper>
                          <H4>
                            {selectedMethod ===
                              paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_VIA_LINK
                              ? 'Payment link '
                              : 'Proforma invoice '}
                            generated successfully
                          </H4>
                        </JustifyContentWrapper>
                        {selectedMethod ===
                          paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_VIA_LINK && (
                            <JustifyContentWrapper>
                              <LinkWrapper>
                                <LinkWrapperSpan>
                                  <CopyToClipboard text={payNowLink} size={16} />
                                  {' '}
                                </LinkWrapperSpan>
                                <LinkWrapperSpan>{payNowLink}</LinkWrapperSpan>
                              </LinkWrapper>
                            </JustifyContentWrapper>
                          )}
                        <JustifyContentWrapper>
                          <P>
                            {selectedMethod ===
                              paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_VIA_LINK
                              ? `Upon payment, gift cards will be emailed to your recipients`
                              : `Please share the payment details with us. Upon successful updation, gift cards will be emailed to your recipients`}
                          </P>
                        </JustifyContentWrapper>
                        <Layout gap={0} style={{ marginTop: '4rem' }}>
                          {selectedMethod ===
                            paymentRequestTypeEnum.PAYMENT_REQUEST_TYPE_PAY_OFFLINE ? (
                              <>
                                <Layout.Item colD={6} colT={6} colM={6}>
                                  <DownloadButtonWrapper>
                                    <Button
                                      style={ReportModalBtnStyle}
                                      onClick={closeModal}
                                    >
                                      {' '}
                                      Okay
                                      {' '}
                                    </Button>
                                  </DownloadButtonWrapper>
                                </Layout.Item>
                                <Layout.Item colD={6} colT={6} colM={6}>
                                  <DownloadButtonWrapper
                                    href={paymentStatementFilePath}
                                    target='_blank'
                                    rel='noreferrer'
                                  >
                                    <Button style={ReportModalBtnStyleRed}>
                                      {' '}
                                      Download
                                      {' '}
                                    </Button>
                                  </DownloadButtonWrapper>
                                </Layout.Item>
                              </>
                          ) : (
                            <Layout.Item colD={12} colT={12} colM={12}>
                              <DownloadButtonWrapper>
                                <Button
                                  style={ReportModalBtnStyle}
                                  onClick={closeModal}
                                >
                                  {' '}
                                  Okay
                                  {' '}
                                </Button>
                              </DownloadButtonWrapper>
                            </Layout.Item>
                          )}
                        </Layout>
                      </ContentsWrapper>
                    </AlignItemsWrapper>
                  </ReponseHeader>
                )}
              </PollingStateWrapper>
            </GiftingPlanResponseStateWrapper>
          </>
        )}
      </Card.Body>
      {!programPollingStarted &&
        !payReqPollingStarted &&
        payNowLink === '' &&
        paymentStatementFilePath === '' && (
          <Card.Footer style={footerStyle}>
            <Button
              onClick={handleConfirmClick}
              loading={creatingProgram}
              disabled={!selectedMethod}
            >
              Confirm
            </Button>
          </Card.Footer>
        )}
    </>
  );
};

ConfirmAdhocProgramCreation.propTypes = {
  subTitle: PropTypes.string,
  planData: PropTypes.objectOf(PropTypes.any),
  creatingProgram: PropTypes.bool,
  createProgram: PropTypes.func,
  createProgramSuccess: PropTypes.bool,
  programAmount: PropTypes.number,
  pocEmail: PropTypes.string,
  programID: PropTypes.string,
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  totalEmployees: PropTypes.number,
  payableAmount: PropTypes.number,
  executionDate: PropTypes.string,
  showErrorToast: PropTypes.func,
};

ConfirmAdhocProgramCreation.defaultProps = {
  subTitle: '',
  planData: {},
  creatingProgram: false,
  createProgram: _noop,
  createProgramSuccess: false,
  programAmount: 0,
  pocEmail: '',
  programID: '',
  selectedWorkspace: {},
  totalEmployees: 0,
  payableAmount: 0,
  executionDate: '',
  showErrorToast: _noop,
};

export default ConfirmAdhocProgramCreation;
